import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ProductService {
  private products = [
    {
      id: "community",
      title: "Estate360 Community",
      heading: "The Digital Core ",
      highlight: "of Every Modern Estate",
      description:
        "Estate360 Community transforms everyday estate living with visitor QR codes, a resident-focused mobile app, security tools, and emergency alert systems — all in one powerful platform.",
      image: "../../../assets/GIFS/community2.gif",
    },
    {
      id: "homes",
      title: "Estate360 Homes",
      heading: "Buy or Rent Easily",
      highlight: "Secure Property Listings",
      description:
        "Estate360 Homes connects buyers, sellers, and agents with verified property listings, in-app chat, and move-in logistics.",
      image:
        "https://placehold.co/700x450/2ECC71/FFFFFF?text=Estate360+Homes+Illustration",
    },
    {
      id: "developer",
      title: "Estate360 Developer",
      heading: "Developer-friendly",
      highlight: "Access Management",
      description:
        "Estate360 Developer equips estate builders with real-time workforce monitoring, synchronized plot sales, and daily updates.",
      image:
        "https://placehold.co/700x450/336799/FFFFFF?text=Estate360+Developer+Illustration",
    },
    {
      id: "organization",
      title: "Estate360 Organization",
      heading: "Enterprise-grade",
      highlight: "Visitor Management",
      description:
        "Estate360 Organization offers visitor scheduling, role-based access, and estate security sync for offices, schools, and hospitals.",
      image:
        "https://placehold.co/700x450/E67E22/FFFFFF?text=Estate360+Organization+Illustration",
    },
  ];

  constructor() {}

  getAllProducts() {
    return this.products;
  }

  getProductById(id: string) {
    return this.products.find((product) => product.id === id);
  }
}
